import {ChangeDetectionStrategy, Component, computed, HostBinding, inject, input, OnInit} from '@angular/core';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {StoryblokDirective} from '@core/directives/storyblok.directive';
import {DynamicModule} from 'ng-dynamic-component';
import {NgOptimizedImage} from '@angular/common';
import {StoryblokBaseComponent} from '../storyblok-base.component';
import {StoryblokDynamicInputService} from '@core/services/storyblok-dynamic-input.service';

@Component({
  selector: 'app-storyblok-image',
  templateUrl: './storyblok-image.component.html',
  styleUrls: ['./storyblok-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective, DynamicModule, NgOptimizedImage]
})
export class StoryblokImageComponent extends StoryblokBaseComponent implements OnInit {
  private storyblokStylingService = inject(StoryblokStylingService);
  private storyblokDynamicInputService = inject(StoryblokDynamicInputService);

  readonly general_styling = input<any>();
  readonly _editable = input<any>();
  readonly asset = input<any>();
  readonly external_url = input<string>();
  readonly horizontal_alignment = input<'left' | 'center' | 'right'>();
  readonly vertical_alignment = input<'left' | 'center' | 'right'>();
  @HostBinding('class') class: any;

  // Computed signal for image element classes
  imageClasses = computed(() => {
    const classes = ['image-aligned'];

    const horizontalAlignment = this.horizontal_alignment();
    if (horizontalAlignment) {
      classes.push(`horizontal-${horizontalAlignment}`);
    }

    const verticalAlignment = this.vertical_alignment();
    if (verticalAlignment) {
      classes.push(`vertical-${verticalAlignment}`);
    }

    return classes.join(' ');
  });

  ngOnInit() {
    const baseClasses = this.storyblokStylingService.getClassList(this.general_styling());
    const alignmentClasses = [];

    // Only add alignment classes if values are defined
    const horizontalAlignment = this.horizontal_alignment();
    if (horizontalAlignment) {
      alignmentClasses.push(`horizontal-alignment-${horizontalAlignment}`);
    }

    const verticalAlignment = this.vertical_alignment();
    if (verticalAlignment) {
      alignmentClasses.push(`vertical-alignment-${verticalAlignment}`);
    }

    this.class = [...baseClasses, ...alignmentClasses];
  }

  getImageSrc() {
    const asset = this.asset();
    if (asset.id) {
      return asset.filename;
    }
    const external_url = this.external_url();
    if (external_url) {
      return this.storyblokDynamicInputService.replaceDynamicInputs(external_url)();
    }
    return '';
  }

}
